export enum EWelcomeMessagesKeys {
  TITLE = "ONBOARDING.WELCOME.TITLE",
  SUBTITLE = "ONBOARDING.WELCOME.SUBTITLE",
  BUTTON = "ONBOARDING.WELCOME.BUTTON",
  DETAILS_SHARE = "ONBOARDING.WELCOME.DETAILS_SHARE",
  DETAILS_COLLABORATE = "ONBOARDING.WELCOME.DETAILS_COLLABORATE",
  DETAILS_PAPERWORK = "ONBOARDING.WELCOME.DETAILS_PAPERWORK",
}
